import React, { useState } from "react"
import style from "./HeroSection.module.scss"
import cs from "classnames"
import { Modal } from "@mui/material"
import { APP_DISPLAY_NAME, EXTENSION_CWS_URL } from "platform-common/index"
import { tomboWalkthroughYoutubeId } from "platform-common/links"
import { CALENDLY_LINK } from "platform-common/util/contact"

const HeroSection: React.FC = () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <div className={style.heroSection}>
      <div className={style.circle} />
      <div className={style.textContainer}>
        <div className={style.heroText}>
          <h1>
            Source candidates <strong className={style.textStyle}>3x </strong>
            faster<br></br>And get <strong className={style.textStyle}>2x</strong> more responses <br></br>With
            Generative AI
          </h1>
          <img
            className={style.heroUnderline}
            src="/images/landing/Tombo-heroUnderline.webp"
            alt={`${APP_DISPLAY_NAME} HeroUnderline`}
            width={260}
            height={18}
          />
          <p>
            Up to 80% of sourcing & recruiting are repetitive
            <br /> tasks that can now be automated.
          </p>
          <div className={style.buttons}>
            <a href={EXTENSION_CWS_URL} className={style.primaryButton}>
              Start For Free
            </a>
            <a href={CALENDLY_LINK} className={style.secondaryButton} target="_blank" rel="noreferrer">
              Get A Demo
            </a>
          </div>
        </div>
      </div>
      <div className={cs(style.heroImageContainer, "tmb-w-full tmb-justify-around")}>
        <div className={cs(style.heroImage, "tmb-relative tmb-max-w-[600px]")}>
          <img
            src="/images/landing/Tombo-laptop.svg"
            alt={`${APP_DISPLAY_NAME} HeroImage`}
            width="100%"
            height="auto"
          />
          <div
            className="tmb-absolute tmb-z-2 tmb-right-[14%] tmb-left-[12.5%] tmb-w-[75%] tmb-h-[74%] tmb-top-[5%] tmb-cursor-pointer tmb-overflow-hidden"
            onClick={() => setShowModal(true)}
          >
            <img
              src="images/landing/YoutubePlaceholder.webp"
              alt="Youtube video"
              className="tmb-w-full tmb-pointer-events-none tmb-aspect-[20/12.7] tmb-h-full"
            />
          </div>
        </div>
      </div>

      <Modal open={showModal} onClose={() => setShowModal(false)} className="flex">
        <iframe
          className="tmb-mx-auto tmb-mt-[5vh] tmb-aspect-[17/13.5] tmb-w-[95%] xl:tmb-max-w-[1370px] tmb-max-h-[90vh] tmb-flex"
          src={`https://www.youtube.com/embed/${tomboWalkthroughYoutubeId}?autoplay=1`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </Modal>
    </div>
  )
}

export default HeroSection
